import { Reveal, Chapter, SectionHead } from "@/components/Reveal";

const PHASES = [
  { n: "01", title: "Founding", note: "Community, waitlist and verifier selection.", status: "Now open" },
  { n: "02", title: "Pilot", note: "Contributor missions and live verification.", status: "Next" },
  { n: "03", title: "Network", note: "More cities, contributors and data layers.", status: "Planned" },
  { n: "04", title: "Production", note: "Live network and enterprise services.", status: "Planned" },
];

export const Roadmap = () => {
  return (
    <section id="roadmap" className="relative py-28 sm:py-40 bg-ink-900/40" data-testid="section-roadmap">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <Chapter label="Roadmap" />
        <SectionHead title={"From Founding\nto a global network."} className="max-w-2xl" />

        <div className="relative mt-20 sm:mt-24">
          <div className="absolute left-0 right-0 top-[5px] h-px bg-white/[0.08]" aria-hidden="true" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
            {PHASES.map((p, i) => (
              <Reveal key={p.n} delay={0.1 * i} y={16}>
                <div data-testid={`roadmap-phase-${p.n}`}>
                  <span className="relative flex h-[11px] w-[11px]">
                    {i === 0 && (
                      <span className="absolute inline-flex h-full w-full rounded-full bg-signal-cyan opacity-60 soft-ping" />
                    )}
                    <span className={`relative inline-flex h-[11px] w-[11px] rounded-full ${i === 0 ? "bg-signal-cyan" : "bg-ink-950 border border-white/25"}`} />
                  </span>
                  <div className="mt-7 text-xs font-semibold uppercase tracking-[0.22em] text-zinc-600">
                    Phase {p.n}
                  </div>
                  <h3 className="mt-2 font-display text-2xl font-semibold tracking-tight text-mist">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-steel max-w-xs">{p.note}</p>
                  <div className={`mt-4 text-xs font-medium ${i === 0 ? "text-signal-cyan" : "text-steel/70"}`}>
                    {p.status}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
